import React from 'react';
import { Box } from '@mui/material';

import { Card } from '@occc-app/design-system';
import { Tab, Tabs } from '@occc/ui-design-system';

import { MessagingCampaignTabs } from './messaging-campaign-configure.constants';
import { TabItem } from './messaging-campaign-configure.types';

export type ConfigureLayoutProps = {
  children?: React.ReactNode;
  selectedTab: MessagingCampaignTabs;
  onTabSelected?: (value: MessagingCampaignTabs) => void;
  tabs: TabItem[];
  title: string;
  subtitle: string;
  loading: boolean;
};

export const MessagingCampaignConfigureLayout = ({
  children,
  selectedTab,
  onTabSelected,
  tabs,
}: ConfigureLayoutProps) => {
  return (
    <>
      <Box ml={2}>
        <Tabs
          indicatorColor='secondary'
          textColor='secondary'
          value={selectedTab}
          onChange={(_e, value) => onTabSelected?.(value)}
        >
          {tabs.map((item) => (
            <Tab key={item.value} value={item.value} label={item.label} disabled={item.disabled} />
          ))}
        </Tabs>
      </Box>
      <Card>{children}</Card>
    </>
  );
};
